import React, { JSX } from "react";
import { ResponsiveContainer } from "recharts";
import { BenchmarkingDashboardDetailsTypeEnum } from "@app/overviews/network-benchmarking-dashboard/dashboard-details";
import { ProviderOverlapData } from "@app/overviews/network-benchmarking-dashboard/tiles/shared";
import { colors } from "@app/overviews/network-benchmarking-dashboard/tiles/utility";
import { printNumberAsString } from "@app/shared/waffles";

interface ProviderOverlapProps {
  canDrillIn: boolean;
  data: ProviderOverlapData;
  onDashboardDetailsViewClick: (
    drillinOption: BenchmarkingDashboardDetailsTypeEnum,
    clickedCount: number,
    selectedVersionId?: number,
    networkOverlappingCount?: number,
    isGhost?: boolean,
  ) => void;
  providerOverlapHeight: number;
}

const ProviderOverlap = (props: ProviderOverlapProps): JSX.Element => {
  return (
    <React.Fragment>
      {!!props.data && (
        <div style={{ height: props.providerOverlapHeight, width: "100%" }}>
          <ResponsiveContainer width="100%" height="100%">
            <svg viewBox="-10 30 500 285">
            <circle
              className={props.canDrillIn ? "comparison-chart" : ""}
              id={`benchmarking-dashboard__provider-overlap--primary-${props.data.inPrimaryOnlyCount}`}
              r="120"
              cy="180"
              cx="180"
              rx="120"
              ry="120"
              fill={colors.green}
              onClick={(props.canDrillIn && !!props.data.inPrimaryOnlyCount) ? (() => props.onDashboardDetailsViewClick(BenchmarkingDashboardDetailsTypeEnum.VennDiagramPrimaryOnly, props.data.inPrimaryOnlyCount)) : null}
            />
            <circle
              className={props.canDrillIn ? "comparison-chart" : ""}
              id={`benchmarking-dashboard__provider-overlap--comparison-${props.data.inComparisonsOnlyCount}`}
              r="120"
              cy="180"
              cx="300"
              rx="120"
              ry="120"
              fill={colors.lightBlue}
              onClick={(props.canDrillIn && !!props.data.inComparisonsOnlyCount) ? (() => props.onDashboardDetailsViewClick(BenchmarkingDashboardDetailsTypeEnum.VennDiagramComparisonOnly, props.data.inComparisonsOnlyCount)) : null}
            />
            <path
              className={props.canDrillIn ? "comparison-chart" : ""}
              id={`benchmarking-dashboard__provider-overlap--common-${props.data.commonCount}`}
              d="M 240,76.076950 C 277.12813,97.512885 300,137.12813 300,180 C 300,222.87187 277.12813,262.48712 240,283.92305 C 202.87187,262.48712 180,222.87187 180,180 C 180,137.12813 202.87187,97.512885 240,76.076950"
              fill={colors.cyan}
              onClick={(props.canDrillIn && !!props.data.commonCount) ? (() => props.onDashboardDetailsViewClick(BenchmarkingDashboardDetailsTypeEnum.VennDiagramCommon, props.data.commonCount)) : null}
            />
            <text x="110" y="50" fontSize="14px">Primary Network</text>
            <text x="105" y="180" fontSize="14px">{printNumberAsString(props.data.inPrimaryOnlyCount, "0")}</text>
            <text x="227" y="180" fontSize="14px">{printNumberAsString(props.data.commonCount, "0")}</text>
            <text x="240" y="50" fontSize="14px">Comparison Networks</text>
            <text x="340" y="180" fontSize="14px">{printNumberAsString(props.data.inComparisonsOnlyCount, "0")}</text>
          </svg>
          </ResponsiveContainer>
        </div>
      )}
    </React.Fragment>
  )
}

export default ProviderOverlap;
